import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useLiveSupport } from '../hooks/useLiveSupport';

const pageLabelMap = {
  '/': 'ana sayfa',
  '/live': 'canli maclar',
  '/analysis': 'ai analizi',
  '/premium-coupons': 'premium kuponlar',
  '/risky-analysis': 'riskli denenebilir',
  '/admin': 'admin paneli',
  '/login': 'giris',
  '/register': 'kayit'
};

const LiveSupportWidget = () => {
  const { user, isPremium } = useAuth();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState('');
  const [leadEmail, setLeadEmail] = useState('');
  const currentPage = useMemo(() => pageLabelMap[location.pathname] || 'genel', [location.pathname]);
  const couponPageMode = location.pathname === '/premium-coupons';
  const {
    messages,
    sending,
    error,
    canPromotePremium,
    supportConfig,
    leadSaving,
    sendMessage,
    saveLead,
    loadSupportConfig
  } = useLiveSupport({ user, isPremium });

  useEffect(() => {
    loadSupportConfig();
  }, [loadSupportConfig]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const message = draft;
    setDraft('');
    await sendMessage(message, currentPage);
  };

  const handleLeadSubmit = async (event) => {
    event.preventDefault();
    if (!leadEmail.trim()) return;
    await saveLead({ email: leadEmail, name: user?.name || '' });
    setLeadEmail('');
  };

  return (
    <div className={`live-support ${open ? 'open' : ''} ${couponPageMode ? 'coupon-page' : ''}`}>
      {open ? (
        <div className="live-support-panel">
          <div className="live-support-header">
            <div>
              <strong>Canli Destek</strong>
              <span>{canPromotePremium ? 'Premium destek ve uyelik yardimi' : 'Canli destek aktif'}</span>
            </div>
            <button type="button" className="live-support-close" onClick={() => setOpen(false)}>×</button>
          </div>

          <div className="live-support-messages">
            {messages.map((message, index) => (
              <div key={`${message.role}-${index}`} className={`live-support-bubble ${message.role}`}>
                {message.content}
              </div>
            ))}
            {sending ? <div className="live-support-bubble assistant">Yaziyor...</div> : null}
          </div>

          {error ? <div className="live-support-error">{error}</div> : null}

          <div className="live-support-actions">
            {supportConfig.whatsappEnabled ? (
              <a className="live-support-whatsapp" href={supportConfig.whatsappLink} target="_blank" rel="noreferrer">
                WhatsApp'a Gec
              </a>
            ) : null}
            {canPromotePremium ? (
              <div className="live-support-sales-note">
                Premium, canli analiz ve ozel kuponlar icin admin: {supportConfig.adminEmail}
              </div>
            ) : null}
          </div>

          <form className="live-support-lead-form" onSubmit={handleLeadSubmit}>
            <input
              type="email"
              value={leadEmail}
              onChange={(event) => setLeadEmail(event.target.value)}
              placeholder="Mailinizi birakin, size donelim"
            />
            <button type="submit" className="ghost-btn" disabled={leadSaving || !leadEmail.trim()}>
              {leadSaving ? 'Kaydediliyor...' : 'Mail Birak'}
            </button>
          </form>

          <form className="live-support-form" onSubmit={handleSubmit}>
            <textarea
              rows="3"
              value={draft}
              onChange={(event) => setDraft(event.target.value)}
              placeholder="Mesajinizi yazin..."
            />
            <button type="submit" className="btn-primary" disabled={sending || !draft.trim()}>
              Gonder
            </button>
          </form>
        </div>
      ) : null}

      <button type="button" className="live-support-trigger" onClick={() => setOpen((current) => !current)}>
        <span>Canli Destek</span>
        <small>AI destek</small>
      </button>
    </div>
  );
};

export default LiveSupportWidget;
